import React from 'react';
import { AdminButton } from '../components';

interface LegalPaginationProps {
  label: string;
  page: number;
  pageSize: number;
  totalCount: number;
  onPage: (page: number) => void;
}

const LegalPagination: React.FC<LegalPaginationProps> = ({
  label,
  page,
  pageSize,
  totalCount,
  onPage,
}) => {
  const pageCount = Math.max(1, Math.ceil(totalCount / pageSize));
  if (pageCount <= 1) {
    return null;
  }
  const normalizedLabel = label.toLocaleLowerCase();
  return (
    <nav className="admin-legal-pagination" aria-label={`${label} pagination`}>
      <AdminButton
        aria-label={`Previous ${normalizedLabel} page`}
        disabled={page <= 1}
        onClick={() => onPage(page - 1)}
      >
        Previous
      </AdminButton>
      <span role="status" aria-label={`${label} page`}>
        Page {page} of {pageCount} · {totalCount.toLocaleString()} results
      </span>
      <AdminButton
        aria-label={`Next ${normalizedLabel} page`}
        disabled={page >= pageCount}
        onClick={() => onPage(page + 1)}
      >
        Next
      </AdminButton>
    </nav>
  );
};

export default LegalPagination;
